import React from "react";
import { Box, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import Footer from "./Footer/Footer";
import Image from "@/Components/Buttons/Image";
import logo from "@/Assets/logo.png";
import { useColor } from "@/Context/ColorContext";

const AuthLayout = () => {
  const { color } = useColor();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
        height: "100vh", // Full viewport height
      }}
    >
      {/* Left Side */}
      <Box
        sx={{
          width: "62%",
          display: "flex",
          backgroundColor: color || "var(--brand-900)",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-start",
          px: 12,
          py: 8,
          overflow: "hidden",
        }}
        className="my-container"
      >
        <Box sx={{ textAlign: "left" }}>
          <Typography
            // variant="titlePage"
            mb={3}
            sx={{
              background: "var(--linear-10)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
              fontSize: "clamp(3rem,2.7vw, 4.5rem)"
            }}
          >
            Track and Trace
          </Typography>

          <Box sx={{ width: "70%" }}>
            <Typography 
            // variant="title"
            sx={{ fontSize: "clamp(1.7rem,2vw, 3rem)" }}
            >
              Tracking your shipment has never been so easy
            </Typography>
          </Box>
        </Box>

        {/* Global Footprints Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography
            variant="subheading"
            fontWeight={600}
            color="var(--yellow-900)"
          >
            Our Global Footprints
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 10,
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                // variant="titlePage"
                fontWeight={400}
                sx={{ fontSize: "clamp(1.7rem,2.5vw, 4rem)" }}
              >
                5000+
              </Typography>
              <Typography
                color="var(--gray-500)"
                sx={{ fontSize: "clamp(1rem,1.2vw, 1.3rem)" }}
              >
                Customers
              </Typography>
            </Box>
            <Box>
              <Typography
                // variant="titlePage"
                fontWeight={400}
                sx={{ fontSize: "clamp(1.7rem,2.5vw, 3.5rem)" }}
              >
                50+
              </Typography>
              <Typography
                color="var(--gray-500)"
                sx={{ fontSize: "clamp(1rem,1.2vw, 1.3rem)" }}
              >
                Countries
              </Typography>
            </Box>
            <Box>
              <Typography
                // variant="titlePage"
                fontWeight={400}
                sx={{ fontSize: "clamp(1.7rem,2.5vw, 3.5rem)" }}
              >
                1 Million+
              </Typography>
              <Typography
                color="var(--gray-500)"
                sx={{ fontSize: "clamp(1rem,1.2vw, 1.3rem)" }}
              >
                Active users
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Right Side */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "var(--gray-0)",
          overflowY: "auto", // Enable vertical scrolling
          // height: "100vh", // Full height for scroll container
          // overflow: "hidden", // Prevent outer scroll
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            px: {md : 2.5 , lg : 10 , xl : 19},
            py: 5,
            // flexShrink: 0,
          }}
        >
          <Image image={logo} />
        </Box>

        {/* Scrollable Content Area */}
        <Box
          sx={{
            px: {md : 3.5 , lg : 11 , xl : 13},
            flex: 1,
            "& .MuiFormHelperText-root": {
              visibility: "hidden",
              display: "block",
            },
            "& .Mui-error": {
              visibility: "visible",
            },
          }}
        >
          <Outlet />
        </Box>

        {/* Footer */}
        <Box
          sx={{
            // flexShrink: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            px: 7,
            py: 2,
          }}
        >
          {/* <Box
            sx={{
              width: "100%",
              maxWidth: { xs: 300, sm: 350, md: 300, lg: 400 },
              textAlign: "center",
            }}
          > */}
          <Footer />
          {/* </Box> */}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
